
import templateTabs from '@/app-template/lib/pages/Tabs.vue';
export default {
  name: "Tabs",
  components: { templateTabs },
};
